export enum ReportTaskState {
  Ignore = 1,
  DeleteReportedContent,
  BlockContentAccount,
}
